import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'

export function RequireAuth({ children, role }: { children: React.ReactNode; role?: 'TENANT_ADMIN' | 'SUPER_ADMIN' | 'MANAGER' }) {
  const token = useAuthStore((s) => s.accessToken)
  const user = useAuthStore((s) => s.user)
  const location = useLocation()
  if (!token || !user) return <Navigate to="/login" replace state={{ from: location }} />
  if (role === 'SUPER_ADMIN' && user.role !== 'SUPER_ADMIN') return <Navigate to="/" replace />
  if (role === 'TENANT_ADMIN' && !(user.role === 'TENANT_ADMIN' || user.role === 'SUPER_ADMIN')) return <Navigate to="/" replace />
  return <>{children}</>
}
